module.exports = "<button (click)=\"dialogShow()\" class=\"btn btn-xs main-color\" aria-label=\"forgot password\">Forgot Password ...</button>\n"